/* @flow */

import CommissionInvoice from './commissionInvoice';

export default class CommissionInvoiceIsoPerson {
  id: number;
  name: string;
  invoices: CommissionInvoice[];
  debtAmount: number;
  financedAmount: number;
  paidServiceFee: number;
  invoiceCommission: number;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
    this.invoices = [];
    this.debtAmount = 0;
    this.financedAmount = 0;
    this.paidServiceFee = 0;
    this.invoiceCommission = 0;
  }
}
